import React from "react";

export default class Welcome extends React.Component {
    constructor() {
        super();
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="back19" style={{ "position": "relative", "height": '300px' }}>
                <div className="sports_widget_container">
                    Editorji
                </div>
                <p style={{ 'textAlign': 'center', 'color': '#ffffff', 'marginTop': '23%;' }}> Welcome to Editorji</p>
            </div>
        )
    }
}